import * as ko from 'knockout';

let template = require('raw-loader!../../templates/not_found.html').default;

export let notFound = { name: 'not-found', template: template };

ko.components.register(notFound.name, notFound);
